<script setup lang="ts">
import { type ProductDetails, ShippingType } from "mws-ts-v2-sdk";

const { product } = defineProps<{
  product: ProductDetails;
  isLoading: boolean;
  isSidebarDetails?: boolean;
}>();

const { data: estimatedProductCosts, isLoading } = useEstimatedProductCosts(
  () => product,
);
</script>

<template>
  <div>
    <p
      v-if="product.shippingType === ShippingType.FreeShipping"
      class="text-platform-success font-semibold"
    >
      {{ $t("product.description.shippingDetails.freeShipping") }}
    </p>

    <template v-else>
      <span>
        {{ $t("product.description.shippingDetails.estimatedShippingCosts") }}
      </span>
      <BaseSkeletonLoader
        v-if="isLoading"
        class="inline pb-1"
        :width="60"
        :height="24"
      />
      <strong v-else-if="estimatedProductCosts?.shippingCost?.currency">
        <BaseCurrency
          :iso="estimatedProductCosts?.shippingCost.currency"
          :value="estimatedProductCosts?.shippingCost.price"
          :show-decimals="true"
          aria-label="estimated shipping cost"
        />
      </strong>
    </template>
  </div>
</template>
